module.exports = __webpack_public_path__ + "static/gill-5a743bfca5e7d578904d60493a0e343c.jpg";